import { StaticImage } from "gatsby-plugin-image";
import React from "react";

const URLS = {
  home: "/",
  about: "/o-nas/",
  blog: "/magazin/",
  goldBlog: "https://www.kapitolgold.cz/zajimavosti-o-investicnich-kovech/",
  contactForm: "/kontaktni-formular/",
  contactFormSuccess: "/kontaktni-formular-ok/",
  contact: "/kontakt/",
  situations: "/s-cim-pomuzeme/",
  stories: "/pribehy/",
  companyLegal: "https://or.justice.cz/ias/ui/rejstrik-firma.vysledky?subjektId=571348&typ=PLATNY",
  career: "/kariera/",
  christopherFoundation: "https://www.krystufek.cz/",
  christopherFoundationVideo: "https://www.youtube.com/embed/zbHWCCbW3b0?autoplay=1",
  careerVideo: "https://player.vimeo.com/video/358244220?title=0&byline=0&portrait=0&autoplay=1",
  linked: "https://cz.linkedin.com/company/kapitol-pojistovaci-a-financni-poradenstvi",
  fb: "https://cs-cz.facebook.com/kapitolczech/",
  instagram: "https://www.instagram.com/kapitol.cz/",
  yt: "http://youtube.com/channel/UCPq0pbyxbIC6HfQ4HLAMkuQ",
  gdpr: "/gdpr-zasady-zpracovani-osobnich-udaju/",
  complaintsProcedure: "/wp-content/uploads/2022/10/reklamacni-rad.pdf",
  consumerLoansFile: "/spotrebitelske-uvery/",
  whistleblowing: "/whistleblowing/",
  cookies: "/cookies",
  ethicalCode: "/wp-content/uploads/2020/11/Eticky_kodex-KAPITOL.pdf",
  mandatoryInformationPrefix: "/povinne-zverejnovane-informace",
  carInsurance: "/autopojisteni/",
  goldEshop: "https://www.kapitolgold.cz/e-shop/",
  ESGInsurance: "/esg",
  ESGInvestment: "/esg",
};

const kapitolSites = [
  {
    id: "kfp",
    url: "/",
    label: "Finanční poradenství",
    active: true,
  },
  {
    id: "real",
    url: "https://www.kapitolreality.cz/",
    label: "Reality",
    external: true,
    active: false,
  },
  {
    id: "gold",
    url: "https://www.kapitolgold.cz/",
    label: "Cenné kovy",
    external: true,
    active: false,
  },
  {
    id: "car",
    url: "https://www.kapitolautopojisteni.cz/",
    label: "Autopojištění",
    external: true,
    active: false,
  },
];

const mainNavigation = [
  {
    url: "/s-cim-pomuzeme/",
    label: "S čím pomůžeme",
  },
  {
    url: "/magazin/",
    label: "Magazín",
  },
  {
    url: "/kariera/",
    label: "Kariéra",
  },
  {
    url: "/o-nas/",
    label: "O nás",
  },
  {
    url: "/kontakt/",
    label: "Kontakt",
  },
];

const contact = {
  phone: "910&nbsp;880&nbsp;088",
  phoneLink: "910880088",
  mail: "info@kapitol.cz",
};

const board = [
  {
    image: <StaticImage src={"../assets/images/aboutUs/board/michal-pobuda.jpg"} display="block" alt={"Ing. Michal Pobuda"} style={{ borderRadius: "6px" }} />,
    name: "Ing. Michal Pobuda",
    position: "Předseda představenstva KAPITOLu",
  },
  {
    image: <StaticImage src={"../assets/images/aboutUs/board/radek-milion.jpg"} display="block" alt={"Ing. Radek Milion"} style={{ borderRadius: "6px" }} />,
    name: "Ing. Radek Milion",
    position: "Člen představenstva KAPITOLu",
  },
  {
    image: <StaticImage src={"../assets/images/aboutUs/board/pert-kriz.jpg"} display="block" alt={"Petr Kříž"} style={{ borderRadius: "6px" }} />,
    name: "Petr Kříž",
    position: "Člen představenstva KAPITOLu",
  },
];

const supervisors = [
  {
    name: "Jiří Sýkora",
    position: "Předseda dozorčí rady KAPITOLu.",
  },
  {
    name: "JUDr. Hana Machačová",
    position: "Členka dozorčí rady KAPITOLu.",
  },
  {
    name: "Ing. Pavel Wiesner",
    position: "Člen dozorčí rady KAPITOLu.",
  },
];

const regions = [
  "Hlavní město Praha",
  "Středočeský kraj",
  "Jihočeský kraj",
  "Plzeňský kraj",
  "Karlovarský kraj",
  "Ústecký kraj",
  "Liberecký kraj",
  "Královéhradecký kraj",
  "Pardubický kraj",
  "Kraj Vysočina",
  "Jihomoravský kraj",
  "Olomoucký kraj",
  "Zlínský kraj",
  "Moravskoslezský kraj",
];

export { kapitolSites, mainNavigation, contact, URLS, board, supervisors, regions };
